/* Nova PDP – see sections/nova-pdp.liquid */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Average the corner pixels of an image so its card can match the photo's backdrop.
  function sampleBg(img) {
    return new Promise(function (resolve) {
      var src = img && (img.currentSrc || img.src);
      if (!src) return resolve(null);
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = 40; c.height = 40;
          var x = c.getContext('2d');
          x.drawImage(probe, 0, 0, 40, 40);
          var pts = [[1, 1], [38, 1], [1, 38], [38, 38], [20, 1], [1, 20]];
          var r = 0, g = 0, b = 0;
          pts.forEach(function (p) { var d = x.getImageData(p[0], p[1], 1, 1).data; r += d[0]; g += d[1]; b += d[2]; });
          resolve('rgb(' + Math.round(r / pts.length) + ',' + Math.round(g / pts.length) + ',' + Math.round(b / pts.length) + ')');
        } catch (e) { resolve(null); }
      };
      probe.onerror = function () { resolve(null); };
      probe.src = src.replace(/([?&])width=\d+/, '$1width=80');
    });
  }

  function init(root) {
    if (root.dataset.nvReady) return;
    root.dataset.nvReady = '1';
    root.classList.add('nv-js');

    // ── Keep the local nav glued to the bottom of the theme's sticky header.
    // The theme's --sticky-header-height lags behind when the header collapses on scroll,
    // so measure the header's real bottom edge instead.
    // On phones Concept slides the inner header out of view while its section wrapper stays
    // sticky, so measure the element that actually moves, and keep re-measuring while it animates.
    var themeHeader = document.querySelector('.header-section') || document.querySelector('header');
    var headerInner = themeHeader && (themeHeader.querySelector('[is="sticky-header"], sticky-header, header') || themeHeader);
    var lastTop = -1;
    function isPinned(el) {
      var pos = el && getComputedStyle(el).position;
      return pos === 'sticky' || pos === 'fixed';
    }
    function syncTop() {
      var top = 0;
      if (themeHeader && (isPinned(themeHeader) || isPinned(headerInner))) {
        var a = themeHeader.getBoundingClientRect().bottom;
        var b = headerInner.getBoundingClientRect().bottom;
        var vis = headerInner.getBoundingClientRect().height > 0 && getComputedStyle(headerInner).visibility !== 'hidden';
        top = Math.max(0, Math.round(vis ? Math.min(a, b) : 0));
      }
      if (top !== lastTop) { lastTop = top; root.style.setProperty('--nv-top', top + 'px'); }
    }
    var topQueued = false, followUntil = 0;
    function follow() {
      syncTop();
      if (performance.now() < followUntil) requestAnimationFrame(follow); else topQueued = false;
    }
    function queueTop() {
      followUntil = performance.now() + 700;   // cover the header's slide-in/out transition
      if (topQueued) return;
      topQueued = true;
      requestAnimationFrame(follow);
    }
    window.addEventListener('scroll', queueTop, { passive: true });
    window.addEventListener('resize', queueTop);
    if (themeHeader) {
      themeHeader.addEventListener('transitionend', queueTop);
      themeHeader.addEventListener('animationend', queueTop);
      if ('ResizeObserver' in window) new ResizeObserver(queueTop).observe(themeHeader);
      if ('MutationObserver' in window) new MutationObserver(queueTop).observe(headerInner, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    syncTop();

    // ── Stagger: siblings that reveal together get an increasing delay
    var groups = new Map();
    root.querySelectorAll('.nv-reveal').forEach(function (el) {
      var parent = el.parentElement;
      var n = groups.get(parent) || 0;
      el.style.setProperty('--i', Math.min(n, 6));
      groups.set(parent, n + 1);
    });

    // ── Reveal on scroll (+ count-up when a counter comes into view)
    function countUp(el) {
      if (el.dataset.counted) return;
      el.dataset.counted = '1';
      var to = parseFloat(el.dataset.nvCount);
      var dec = parseInt(el.dataset.decimals || '0', 10);
      if (reduce || isNaN(to)) { el.textContent = to.toFixed(dec); return; }
      var t0 = null, dur = 1400;
      function tick(t) {
        if (!t0) t0 = t;
        var k = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = (to * e).toFixed(dec);
        if (k < 1) requestAnimationFrame(tick);
      }
      el.textContent = (0).toFixed(dec);
      requestAnimationFrame(tick);
    }
    var watch = root.querySelectorAll('.nv-reveal, .nv-bloom, [data-nv-count]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (e.target.hasAttribute('data-nv-count')) countUp(e.target);
          else e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      watch.forEach(function (el) { io.observe(el); });
    } else {
      watch.forEach(function (el) { el.classList.add('is-in'); });
    }

    // ── Scroll-linked effects (hero drift-out, finish zoom-in, bento image settle)
    var hero = root.querySelector('.nv-hero__board');
    var scrubs = [].slice.call(root.querySelectorAll('[data-nv-scrub]'));
    root.querySelectorAll('[data-nv-scrub-group] .nv-tile').forEach(function (t) { scrubs.push(t); });
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var vh = window.innerHeight;
        if (hero) {
          var hr = hero.getBoundingClientRect();
          var out = Math.min(Math.max(-hr.top / (hr.height || 1), 0), 1);
          hero.style.setProperty('--out', out.toFixed(3));
        }
        scrubs.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top > vh || r.bottom < 0) return;
          var p = Math.min(Math.max((vh - r.top) / (vh * 0.75), 0), 1);
          el.style.setProperty('--p', p.toFixed(3));
        });
      });
    }
    if (!reduce) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    // Hero card takes the colour of the photo's backdrop
    var heroMedia = root.querySelector('.nv-hero__board .nv-media');
    if (heroMedia) sampleBg(heroMedia.querySelector('img')).then(function (c) { if (c) heroMedia.style.setProperty('--img-bg', c); });

    // ── Hero tilt on pointer move (desktop)
    var stage = root.querySelector('[data-nv-tilt]');
    if (stage && hero && !reduce && window.matchMedia('(hover: hover)').matches) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        hero.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        hero.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      });
      stage.addEventListener('pointerleave', function () {
        hero.style.setProperty('--ry', '0deg');
        hero.style.setProperty('--rx', '0deg');
      });
    }

    // ── Nova styles showcase
    var styles = root.querySelector('[data-nv-styles]');
    var selectStyle = function () {};
    if (styles) {
      var slides = styles.querySelectorAll('[data-nv-slide]');
      var metas = styles.querySelectorAll('[data-nv-meta]');
      var tabs = styles.querySelectorAll('[data-nv-tab]');
      var idx = parseInt(styles.dataset.start || '0', 10) || 0;
      var timer = null, inView = false, touched = false;
      var stageEl = styles.querySelector('.nv-styles__stage');
      slides.forEach(function (sl, k) {
        var im = sl.querySelector('img');
        if (!im) return;
        var go = function () {
          sampleBg(im).then(function (c) {
            if (!c) return;
            sl.dataset.bg = c;
            if (k === idx) stageEl.style.setProperty('--stage-bg', c);
          });
        };
        if (im.complete && im.naturalWidth) go(); else im.addEventListener('load', go, { once: true });
      });

      selectStyle = function (i, fromUser) {
        var n = slides.length;
        idx = ((i % n) + n) % n;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        metas.forEach(function (m, k) { m.classList.toggle('is-active', k === idx); });
        tabs.forEach(function (t, k) {
          var on = k === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var st = slides[idx].style;
        styles.style.setProperty('--c1', st.getPropertyValue('--c1'));
        styles.style.setProperty('--c2', st.getPropertyValue('--c2'));
        var img = slides[idx].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
        if (slides[idx].dataset.bg) stageEl.style.setProperty('--stage-bg', slides[idx].dataset.bg);
        if (fromUser) { touched = true; stop(); }
      };
      function next() { selectStyle(idx + 1); }
      function start() { if (reduce || touched || timer || !inView) return; timer = setInterval(next, 3200); }
      function stop() { clearInterval(timer); timer = null; }

      tabs.forEach(function (t) { t.addEventListener('click', function () { selectStyle(parseInt(t.dataset.nvTab, 10), true); }); });
      var p = styles.querySelector('[data-nv-style-prev]');
      var nx = styles.querySelector('[data-nv-style-next]');
      if (p) p.addEventListener('click', function () { selectStyle(idx - 1, true); });
      if (nx) nx.addEventListener('click', function () { selectStyle(idx + 1, true); });
      styles.addEventListener('pointerenter', stop);
      styles.addEventListener('pointerleave', start);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) start(); else stop();
        }, { threshold: 0.4 }).observe(styles);
      }
      // preload the other style images once the page is idle
      var whenIdle = window.requestIdleCallback
        ? function (f) { window.requestIdleCallback(f, { timeout: 2500 }); }
        : function (f) { setTimeout(f, 1500); };
      whenIdle(function () {
        slides.forEach(function (s) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; });
      });
      selectStyle(idx);
    }

    // Hero orbs jump to a style in the showcase
    root.querySelectorAll('[data-nv-style-jump]').forEach(function (a) {
      a.addEventListener('click', function () { selectStyle(parseInt(a.dataset.nvStyleJump, 10), true); });
    });

    // ── Highlights carousel
    var track = root.querySelector('[data-nv-track]');
    var prev = root.querySelector('[data-nv-prev]');
    var next2 = root.querySelector('[data-nv-next]');
    if (track && prev && next2) {
      var step = function () { var c = track.querySelector('.nv-card'); return c ? c.getBoundingClientRect().width + 20 : 400; };
      var sync = function () {
        prev.disabled = track.scrollLeft < 8;
        next2.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next2.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }

    // ── Finish viewer (design section)
    var finishName = root.querySelector('[data-nv-finish-name]');
    function showFinish(f) {
      root.querySelectorAll('[data-nv-finish]').forEach(function (b) {
        var on = b.dataset.nvFinish === f;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on);
      });
      root.querySelectorAll('[data-nv-finish-img]').forEach(function (i) { i.classList.toggle('is-active', i.dataset.nvFinishImg === f); });
      if (finishName) finishName.textContent = f.charAt(0).toUpperCase() + f.slice(1);
    }
    root.querySelectorAll('[data-nv-finish]').forEach(function (b) {
      b.addEventListener('click', function () { showFinish(b.dataset.nvFinish); });
    });

    // ── Buy module variant selection
    var input = root.querySelector('[data-nv-variant-input]');
    var add = root.querySelector('[data-nv-add]');
    var soldout = root.querySelector('[data-nv-soldout]');
    root.querySelectorAll('input[name="nv-variant"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        input.value = r.value;
        var ok = r.dataset.available === 'true';
        add.disabled = !ok;
        add.textContent = ok ? 'Add to bag' : 'Sold out';
        soldout.hidden = ok;
        root.querySelectorAll('[data-nv-price]').forEach(function (el) { el.textContent = r.dataset.price.replace(/&amp;/g, '&'); });
        root.querySelectorAll('[data-nv-gallery]').forEach(function (g) { g.classList.toggle('is-active', g.dataset.nvGallery === r.value); });
        showFinish(r.dataset.finish);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  document.querySelectorAll('[data-nv]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nv]').forEach(init);
  });
})();